import React from 'react';
import { motion } from 'framer-motion';

const CandidatesHeroSection = () => {
  const img = `${process.env.PUBLIC_URL}/images/Candidates1.jpg`;
  const fallback = `${process.env.PUBLIC_URL}/Candidates1.jpg`; // just in case it's at /public/

  return (
    // add pt-24 md:pt-28 if a fixed header overlaps
    <section className="w-full bg-white min-h-[100svh] flex items-center">
      <div className="w-full max-w-7xl mx-auto px-6 md:px-12 grid md:grid-cols-2 gap-12 items-center">
        {/* Left: Text */}
        <motion.div
          initial={{ opacity: 0, x: -40 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true, amount: 0.6 }}
          transition={{ duration: 0.7, ease: 'easeOut' }}
        >
          <h1 className="text-5xl md:text-6xl font-bold text-black leading-[1.05] mb-6">
            Shape Your Future With
            <br className="hidden md:block" /> the Right Opportunity
          </h1>
          <p className="text-xl md:text-2xl text-black/80">
            We offer opportunities with our clients across Europe, MENA, US and remote positions.
            Join us in connecting with leading organizations worldwide.
          </p>
        </motion.div>

        {/* Right: Image */}
        <motion.div
          className="
            relative w-full
            h-[320px] md:h-[420px] lg:h-[500px]
            rounded-2xl overflow-hidden shadow-xl ring-1 ring-black/10
            justify-self-end
          "
          initial={{ opacity: 0, x: 40 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true, amount: 0.6 }}
          transition={{ duration: 0.7, ease: 'easeOut', delay: 0.1 }}
        >
          <img
            src={img}
            alt="Candidates discussing opportunities"
            className="absolute inset-0 w-full h-full object-cover object-[50%_40%]"
            loading="eager"
            decoding="async"
            draggable="false"
            onError={(e) => {
              if (e.currentTarget.src !== fallback) e.currentTarget.src = fallback;
            }}
          />
        </motion.div>
      </div>
    </section>
  );
};

export default CandidatesHeroSection;
